export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render (h) {
    const span = h('span', {}, this.$t(this.item.header))
    const icon = h('feather-icon', { props: { icon: 'MoreHorizontalIcon', size: '18' } })
    if (this.$can(this.item.action, this.item.resource)) {
      return h('li', { class: 'navigation-header text-truncate' }, [span, icon])
    }
    return h()
  },
}
